module.exports = function() {
  return new Worker(__webpack_public_path__ + "c28915592eb67f98ae59.worker.js");
};